import {
  LoggingContext,
  logger,
  AriaTo1DSContextUsed,
  CustomContext,
} from "@mwt/web-js-telemetry";

import { APP_ENV, APP_NAME } from "../../../environments/environment";

import { ContextColumns, CustomContextProperties } from "./constants";

export const loggingContext: LoggingContext = {
  customProperties: {
    [ContextColumns.AppName]: APP_NAME,
    [ContextColumns.AppInfoEnvironment]: APP_ENV,
    [ContextColumns.AuthSession]: "",
    [ContextColumns.TenantId]: "",
  },
};

export const updateLoggingContext = (
  commonProperties?: Partial<AriaTo1DSContextUsed>,
  customProperties?: Partial<CustomContextProperties>
) => {
  if (commonProperties) {
    loggingContext.commonProperties = {
      ...loggingContext.commonProperties,
      ...commonProperties,
    };
  }

  if (customProperties) {
    loggingContext.customProperties = {
      ...loggingContext.customProperties,
      ...customProperties,
    } as CustomContext;
  }

  logger.updateContext(loggingContext);
};
